import React, { useState, useEffect } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Button } from '@mui/material';
import api from '../utils/api';

const Sessions = () => {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    api.get('/sessions')
      .then((response) => setSessions(response.data))
      .catch((error) => console.error('Error fetching sessions:', error));
  }, []);

  const invalidateSession = (sid) => {
    api.delete(`/sessions/terminate-session/${sid}`)
      .then(() => setSessions(sessions.filter((session) => session.sid !== sid)))
      .catch((error) => console.error('Error invalidating session:', error));
  };

  return (
    <div>
      <h1>Active Sessions</h1>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Session ID</TableCell>
            <TableCell>User ID</TableCell>
            <TableCell>Expires</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sessions.map((session) => (
            <TableRow key={session.sid}>
              <TableCell>{session.sid}</TableCell>
              <TableCell>{session.userId}</TableCell>
              <TableCell>{new Date(session.expires).toLocaleString()}</TableCell>
              <TableCell>
                <Button onClick={() => invalidateSession(session.sid)} color="secondary">
                  Invalidate
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default Sessions;